import React from "react";
import { problemPoints } from "./data";

/**
 * ProblemSection — sección "El problema".
 */
export function ProblemSection() {
  return (
    <section className="border-b border-gray-200 bg-brand-cream-soft" data-testid="landing-problem-section">
      <div className="container-prose grid md:grid-cols-12 gap-10 py-20">
        <div className="md:col-span-5">
          <p className="text-xs uppercase tracking-[0.22em] text-brand-coral font-semibold mb-3">El problema</p>
          <h2 className="font-serif text-3xl sm:text-4xl text-gray-900 leading-tight mb-6">
            La etapa precontractual concentra la mayor parte del riesgo legal.
          </h2>
          <p className="text-gray-700 leading-relaxed">
            Cada año, miles de procesos de contratación pública en Colombia son anulados,
            sancionados o sufren demoras por errores prevenibles en la etapa precontractual:
            modalidades mal escogidas, estudios previos insuficientes, justificaciones ambiguas,
            falta de análisis del sector, riesgos no mitigados.
          </p>
          <p className="text-gray-700 leading-relaxed mt-3">
            Hoy, validar un proceso antes de publicarlo cuesta tiempo y honorarios elevados — o
            simplemente no se hace.
          </p>
        </div>
        <div className="md:col-span-7">
          <div className="grid sm:grid-cols-2 gap-4">
            {problemPoints.map(({ icon: Icon, text }) => (
              <div
                key={text}
                className="flex gap-3 p-5 bg-white border border-gray-200 rounded-sm hover:border-brand-coral hover:shadow-sm transition-all"
              >
                <Icon className="h-5 w-5 text-brand-coral shrink-0 mt-0.5" aria-hidden="true" />
                <p className="text-sm text-gray-800 leading-relaxed">{text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
